var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9641_344552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9641_344552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.825 20.7008C8.10833 20.2174 6.70833 19.2718 5.625 17.8638C4.54167 16.4551 4 14.8341 4 13.0008C4 12.0508 4.15833 11.1464 4.475 10.2878C4.79167 9.42978 5.24167 8.64245 5.825 7.92578C6.00833 7.72578 6.23333 7.62145 6.5 7.61278C6.76667 7.60478 7.00833 7.70911 7.225 7.92578C7.40833 8.10911 7.50433 8.33411 7.513 8.60078C7.521 8.86745 7.43333 9.11745 7.25 9.35078C6.85 9.86745 6.54167 10.4341 6.325 11.0508C6.10833 11.6674 6 12.3174 6 13.0008C6 14.3508 6.396 15.5551 7.188 16.6138C7.97933 17.6718 9 18.3924 10.25 18.7758C10.4667 18.8424 10.646 18.9674 10.788 19.1508C10.9293 19.3341 11 19.5341 11 19.7508C11 20.0841 10.8833 20.3468 10.65 20.5388C10.4167 20.7301 10.1417 20.7841 9.825 20.7008ZM14.175 20.7008C13.8583 20.7841 13.5833 20.7258 13.35 20.5258C13.1167 20.3258 13 20.0591 13 19.7258C13 19.5258 13.071 19.3341 13.213 19.1508C13.3543 18.9674 13.5333 18.8424 13.75 18.7758C15 18.3758 16.0207 17.6508 16.812 16.6008C17.604 15.5508 18 14.3508 18 13.0008C18 11.3341 17.4167 9.91745 16.25 8.75078C15.0833 7.58411 13.6667 7.00078 12 7.00078H11.925L12.325 7.40078C12.5083 7.58412 12.6 7.81745 12.6 8.10078C12.6 8.38411 12.5083 8.61745 12.325 8.80078C12.1417 8.98411 11.9083 9.07578 11.625 9.07578C11.3417 9.07578 11.1083 8.98411 10.925 8.80078L8.825 6.70078C8.725 6.60078 8.65433 6.49245 8.613 6.37578C8.571 6.25911 8.55 6.13411 8.55 6.00078C8.55 5.86745 8.571 5.74245 8.613 5.62578C8.65433 5.50911 8.725 5.40078 8.825 5.30078L10.925 3.20078C11.1083 3.01745 11.3417 2.92578 11.625 2.92578C11.9083 2.92578 12.1417 3.01745 12.325 3.20078C12.5083 3.38411 12.6 3.61745 12.6 3.90078C12.6 4.18411 12.5083 4.41745 12.325 4.60078L11.925 5.00078H12C14.2333 5.00078 16.125 5.77578 17.675 7.32578C19.225 8.87578 20 10.7674 20 13.0008C20 14.8174 19.4583 16.4341 18.375 17.8508C17.2917 19.2674 15.8917 20.2174 14.175 20.7008Z",
    fill: "#646A82"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.2e62072d7b43fca6147a8c33987eaa0c.svg";
export { ForwardRef as ReactComponent };